module.exports = __webpack_public_path__ + "media/images/ui__arrowUpInactive--dark-b473f0e0c0dd48eb2cc65a79afd2cd6e.png";